import { isChunkLoadError } from "@/lib/errors/is-chunk-load-error";
import { isHookCountMismatchError } from "@/lib/errors/is-hook-count-mismatch-error";
import { isKnownTransientNetworkError } from "@/lib/errors/is-known-transient-network-error";

/**
 * True when a render-phase error is one a reload clears on its own — a stale
 * chunk after a deploy, a dropped network fetch, or a Next.js router hook-count
 * mismatch. Error boundaries use this to reload instead of showing the user an
 * error they cannot act on.
 */
export function isTransientRenderError(error: {
  name?: string;
  message?: string;
  stack?: string;
}): boolean {
  return (
    isKnownTransientNetworkError({
      message: error.message,
      stack: error.stack,
    }) ||
    isChunkLoadError({
      name: error.name,
      message: error.message,
      stack: error.stack,
    }) ||
    isHookCountMismatchError({
      message: error.message,
      stack: error.stack,
    })
  );
}
